import moment from "moment";
import { amountFormat } from "../../../../services/common.service";
import { Empty } from "antd";
import { useTranslation } from "react-i18next";

export default function DepositStatementList({ dataSource, noRecords, }) {
  const { t } = useTranslation();
  return (
    <>
      {noRecords && (
        <Empty
          description={t("pages.my_accounts.casa.no_statements_found", {
            defaultValue: "No Statements Found",
          })}
        />
      )} 
        {dataSource?.length > 0 ? (
        <>
        {dataSource.map((option, idx) => (
          <div key={idx}>
            <div className="account-row-data list-row mb-2">
              <div className="list-row-display-item ">
                <div>
                  <div className="mx-2 ministetement-ref"> {option.refNo}</div>
                  <div className="mx-2 ministatement-desc">
                    {option.txnTypeDesc}
                  </div>
                </div>
              </div>
              <div align="right">
                <div className="account-balance debit">
                  {option.debitOrCredit === "Debit" &&
                    amountFormat(option.amount || "0")}
                </div>
                <div className="account-balance credit">
                  {option.debitOrCredit === "Credit" &&
                    amountFormat(option.amount || "0")}
                </div>
                <div className="list-item-heading">
                  {moment(option.txnDate).format("DD-MM-YYYY")}
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
      ) : !noRecords && (
        <Empty
          description=""
        />
      )}
    </>
  );
}
